import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Button,
  Slider,
  NumericInput,
  FormGroup,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class BattleArena extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      MinLevel: 80,
      RewardItemCodeName: 'ITEM_ETC_ARENA_COIN',
      WinItemCountParty: 3,
      WinItemCountGuild: 1,
      LoseItemCountParty: 5,
      LoseItemCountGuild: 1,
      AFKPunishment: false,
      AFKSeconds: 90,
      PCLimit: true,
      PCLimitCount: 1,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Battle Arena
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>Minumum Level</td>
              <td style={{ width: '360px' }}>
                <Slider
                  min={0}
                  max={120}
                  labelStepSize={10}
                  onChange={this.handleChange('MinLevel')}
                  value={this.state.MinLevel}
                />
              </td>
            </tr>

            <tr>
              <td>Reward Item CodeName</td>
              <td>
                <input
                  className="bp3-input d-block w-75"
                  placeholder="Type an item codename..."
                  value={this.state.RewardItemCodeName}
                  onChange={this.handleChange('RewardItemCodeName')}
                  min={20}
                  max={120}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Random & Party" className="mb-0">
                  Win Item Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '190px' }}
                  value={this.state.WinItemCountParty}
                  placeholder="Type an item count..."
                  onValueChange={this.handleChange('WinItemCountParty')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Random & Party" className="mb-0">
                  Lose Item Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '190px' }}
                  value={this.state.LoseItemCountParty}
                  placeholder="Type an item count..."
                  onValueChange={this.handleChange('LoseItemCountParty')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild & Job" className="mb-0">
                  Win Item Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '190px' }}
                  value={this.state.WinItemCountGuild}
                  placeholder="Type an item count..."
                  onValueChange={this.handleChange('WinItemCountGuild')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="Guild & Job" className="mb-0">
                  Lose Item Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '190px' }}
                  value={this.state.LoseItemCountGuild}
                  placeholder="Type an item count..."
                  onValueChange={this.handleChange('LoseItemCountGuild')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>AFK Punishment</td>
              <td>
                <Switch
                  checked={this.state.AFKPunishment}
                  {...SwitchOnOff}
                  onChange={this.handleChange('AFKPunishment')}
                />
              </td>
            </tr>

            <tr>
              <td>AFK Seconds for Punish</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.AFKPunishment}
                  style={{ width: '190px' }}
                  value={this.state.AFKSeconds}
                  placeholder="Type minutes..."
                  onValueChange={this.handleChange('AFKSeconds')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Battle Arena" className="mb-0">
                  PC Limit
                </FormGroup>
              </td>
              <td>
                <Switch
                  checked={this.state.PCLimit}
                  {...SwitchOnOff}
                  onChange={this.handleChange('PCLimit')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Battle Arena" className="mb-0">
                  PC Limit Count
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.PCLimit}
                  style={{ width: '190px' }}
                  value={this.state.PCLimitCount}
                  placeholder="Type a number..."
                  onValueChange={this.handleChange('PCLimitCount')}
                  min={0}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
